var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInstagramOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.1 39",
    style: {
      enableBackground: "new 0 0 39.1 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#dd5100;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    transform: "translate(14.29 15.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect-2",
    className: "st0",
    d: "M0.3-6h10c2.8,0,5,2.2,5,5V9c0,2.8-2.2,5-5,5h-10c-2.8,0-5-2.2-5-5V-1C-4.7-3.8-2.5-6,0.3-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    className: "st0",
    d: "M9.3,3.4c0.3,2.2-1.2,4.2-3.4,4.5C3.7,8.2,1.7,6.7,1.3,4.5C1,2.4,2.5,0.3,4.7,0 c0.4-0.1,0.8-0.1,1.2,0C7.6,0.3,9,1.6,9.3,3.4z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line",
    className: "st0",
    x1: 10.8,
    y1: -1.5,
    x2: 10.8,
    y2: -1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagramOrange);
export default __webpack_public_path__ + "static/media/icon-Instagram-orange.9bcd2e48d9bc8e664a68aa5143e10b2d.svg";
export { ForwardRef as ReactComponent };